import { SortDescriptor } from '@progress/kendo-data-query';
import * as Redux from 'redux'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type AllActions = Redux.Action & Request.SuccessAction & Actions.SortAction

export const stateReducer = (event: Types.ReducerEvent<Types.SortableObject>) =>
  <T extends Types.SortableObject>
    (state: Types.SortableData<T> = Constants.emptyState, action: AllActions): Types.SortableData<T> => {
  switch (action.type) {
    case Utils.sortTableConstant(event.requestEvent):
    case Utils.sortTableConstant(event.sortEvent):
      return Utils.sortState(state, action.options.value)
    case Request.errorConstant(event.requestEvent):
    case Request.requestConstant(event.requestEvent):
    case event.clearEvent:
      return Constants.emptyState
    case Request.successConstant(event.requestEvent):
      return Utils.sortState(
        (event.normalizer ? event.normalizer(action.payload.response) : action.payload.response),
        [event.defaultSort || Constants.identitySort])
    default:
      return state
  }
}

export const viewReducer = (event: Types.ReducerEvent<Types.SortableObject>) =>
  (state: Types.SortableViewState = Constants.emptyViewState, action: Actions.SortAction) => {
  switch (action.type) {
    case Utils.sortTableConstant(event.requestEvent):
    case Utils.sortTableConstant(event.sortEvent):
      return {
        ...state,
        sort: action.options.value,
      }
    case Request.requestConstant(event.requestEvent):
      return {
        ...state,
        isLoading: true,
      }
    case Request.errorConstant(event.requestEvent):
    case Request.successConstant(event.requestEvent):
      return {
        ...state,
        isLoading: false,
      }
    default:
      return state
  }
}

export type SimpleState = SortDescriptor[]
export const simpleReducer = (prefix: string) => (state: SimpleState = [], action: Actions.SimpleSortAction) => {
  switch (action.type) {
    case Utils.sortTableConstant(prefix):
      return action.sort
    default:
      return state
  }
}

export const reducer = (reducerEvent: Types.ReducerEvent<any>) => Redux.combineReducers({
  data: stateReducer(reducerEvent),
  view: viewReducer(reducerEvent),
})



// WEBPACK FOOTER //
// ./src/components/sortable/reducer.ts